// Public API Documentation V2 still uses API version 1, on a new host.
export const SPAREPARTS_API_BASE_URL = 'https://api.sparepartsfinder.ktm.com/api';
export const SPAREPARTS_PROXY_PATH = '/api/spareparts-proxy';

export function normalizeSparepartsPath(endpoint: string): string | null {
  if (!endpoint.startsWith('/') || endpoint.startsWith('//') || /[\\\r\n#]/.test(endpoint)) {
    return null;
  }
  const [pathname, ...query] = endpoint.split('?');
  let decoded: string;
  try {
    decoded = decodeURIComponent(pathname);
  } catch {
    return null;
  }
  if (decoded.includes('..') || /[\\?#\r\n]/.test(decoded)) return null;
  const path = pathname.startsWith('/api/v1/')
    ? pathname.slice(4)
    : pathname.startsWith('/v1/')
      ? pathname
      : `/v1${pathname}`;
  return `${path}${query.length ? `?${query.join('?')}` : ''}`;
}

export function isSupportedSparepartsPath(path: string): boolean {
  const pathname = path.split('?')[0];
  return [
    /^\/v1\/(brands|models|models\/vin-search|models\/specifications|component-groups)$/,
    /^\/v1\/articles\/[^/]+\/(engine\/)?component-group-templates$/,
    /^\/v1\/component-group-templates\/[^/]+\/spare-parts$/,
    /^\/v1\/downloads\/[^/]+\/[^/]+$/,
  ].some(pattern => pattern.test(pathname));
}

export function getSparepartsErrorMessage(status: number, code?: string): string {
  if (code === 'SPAREPARTS_NOT_CONFIGURED' || status === 401 || status === 403) {
    return 'OEM katalóg čaká na aktiváciu prístupu. Kontaktujte nás, radi vám pomôžeme s výberom dielu.';
  }
  if (status === 501 || code === 'SPAREPARTS_UNSUPPORTED') {
    return 'Nové OEM API túto funkciu neposkytuje. Vyberte motorku podľa značky a modelu alebo použite VIN.';
  }
  if (status === 504) return 'OEM katalóg neodpovedal včas. Skúste to znova.';
  if (status === 400 || status === 422) return 'Skontrolujte zadané údaje a skúste to znova.';
  if (status === 404) return 'Požadované údaje sa v OEM katalógu nenašli.';
  if (status === 429) return 'OEM katalóg je momentálne vyťažený. Skúste to o chvíľu znova.';
  return 'OEM katalóg sa nepodarilo načítať. Skúste to znova neskôr.';
}

export function safeSparepartsActivityId(value: unknown): string | undefined {
  return typeof value === 'string' &&
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value)
    ? value
    : undefined;
}
